import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { SERVICE_ENDPOINT } from '../../constants';
import { BaseResponse, BaseResponseWithData } from '../../models/api';
import {
  GetPaymentFeeResponse,
  GetPaymentProviderResponse,
  GetUrlResponse,
  MYBAncillaryResponse,
  MybCheckBookingResponse,
  MyBCreateBookingRequest,
  MyBCreateBookingResponse,
  MyBGetAncillaryRequest,
  MybMyServicesResponse,
  MYBSeatMapResponse,
  PayOnlineViewModel,
  ReviewBookingRequest,
  SearchMinFare,
} from '../../models/api/portal-booking';
import { ServiceType } from '../../enums';
import {
  SearchFlightDataComRequest,
  SearchFlightResponse,
  SearchFlightComboResponse,
  SearchPriceSuggestResponse,
  SearchPriceSuggestRequest,
} from '../../models/api/flight';
import { GetMyBookingDetailResponse } from '../../models/api/booking';

@Injectable({
  providedIn: 'root',
})
export class PortalBookingHttpService {
  private _http = inject(HttpClient);

  searchFlight(request: SearchFlightDataComRequest) {
    return this._http.post<SearchFlightResponse>(
      SERVICE_ENDPOINT.searchFlight,
      request,
    );
  }

  searchFlightCombo(request: SearchFlightDataComRequest) {
    return this._http.post<SearchFlightComboResponse>(
      SERVICE_ENDPOINT.searchFlight,
      request,
    );
  }

  searchMinFare(request: SearchFlightDataComRequest) {
    return this._http.post<SearchMinFare>(
      SERVICE_ENDPOINT.searchMinFare,
      request,
    );
  }

  searchPriceSuggest(request: SearchPriceSuggestRequest) {
    return this._http.post<SearchPriceSuggestResponse>(
      SERVICE_ENDPOINT.searchPriceSuggest,
      request,
    );
  }

  checkBooking(request: MyBCreateBookingRequest) {
    return this._http.post<BaseResponseWithData<MybCheckBookingResponse>>(
      SERVICE_ENDPOINT.checkBooking,
      request,
    );
  }

  getServicesByVendor() {
    return this._http.post<BaseResponseWithData<Array<MybMyServicesResponse>>>(
      SERVICE_ENDPOINT.getServicesByVendor,
      {},
    );
  }

  getAncillary(type: ServiceType, request: Array<MyBGetAncillaryRequest>) {
    return this._http.post<BaseResponseWithData<Array<MYBAncillaryResponse>>>(
      `${SERVICE_ENDPOINT.getAncillary}/${type}`,
      request,
    );
  }

  getSeatMap(request: MyBGetAncillaryRequest) {
    return this._http.post<BaseResponseWithData<MYBSeatMapResponse>>(
      `${SERVICE_ENDPOINT.getSeatMap}`,
      request,
    );
  }

  booking(request: MyBCreateBookingRequest) {
    return this._http.post<BaseResponseWithData<MyBCreateBookingResponse>>(
      SERVICE_ENDPOINT.booking,
      request,
    );
  }

  getPaymentFee(domain: string, agCode: string) {
    return this._http.get<BaseResponseWithData<GetPaymentFeeResponse>>(
      `${SERVICE_ENDPOINT.getPaymentFee}?domain=${domain}&agCode=${agCode}`,
    );
  }

  bookingReservation(bookingId: number) {
    return this._http.post<BaseResponseWithData<MyBCreateBookingResponse>>(
      `${SERVICE_ENDPOINT.bookingReservation}/${bookingId}`,
      { bookingId },
    );
  }

  payOnline(request: PayOnlineViewModel) {
    return this._http.post<GetUrlResponse>(SERVICE_ENDPOINT.payOnline, request);
  }

  getPaymentProvider() {
    return this._http.get<GetPaymentProviderResponse>(
      SERVICE_ENDPOINT.paymentProvider,
    );
  }

  bookingIssue(bookingId: number) {
    return this._http.post<BaseResponse>(
      `${SERVICE_ENDPOINT.bookingIssue}/${bookingId}`,
      { bookingId },
    );
  }

  reviewBooking(request: ReviewBookingRequest) {
    return this._http.post<GetMyBookingDetailResponse>(
      `${SERVICE_ENDPOINT.reviewBooking}`,
      request,
    );
  }
}
